import axios from '../assets/axios.wrap';
const contextPath = '/remote';
export function getDescr(data) {
    return axios.get(`${contextPath}/descr/get`, { params: data });
}
export function setDescr(data) {
    return axios.postByFormUrl(`${contextPath}/descr/set`, data);
}
export function getDescrList(data) {
    return axios.get(`${contextPath}/descr/select`, { params: data });
}
// 注释信息-下发文件至控制器
export function writeFile(data) {
    return axios.postByFormData(`${contextPath}/descr/writefile`, data);
}
// 注释信息-下发文件至控制器
export function readFile(data) {
    return axios.postByFormUrl(`${contextPath}/descr/readfile`, data);
}
export function setAll(data) {
    return axios.postByFormUrl(`${contextPath}/descr/setall`, data);
}
export function update(data) {
    return axios.postByFormUrl(`${contextPath}/descr/upsert`, data);
}
export function getSchedule(data) {
    return axios.get(`${contextPath}/schedule`, { params: data });
}
export function remove(data) {
    return axios.postByFormUrl(`${contextPath}/descr/delete`, data);
}
export function deleteAll(data) {
    return axios.postByFormUrl(`${contextPath}/descr/deleteall`, data);
}
export function exportDescr(data) {
    return axios.postByJson(`${contextPath}/descr/select/export`, data);
}
export function deleteSchedule(data) {
    return axios.postByFormUrl(`${contextPath}/schedule/delete`, data);
}
// 联动编程
export function getProgram(data) {
    return axios.get(`${contextPath}/program/get`, { params: data });
}
export function setProgram(data) {
    return axios.postByFormUrl(`${contextPath}/program/set`, data);
}
export function exportProgram(data) {
    return axios.postByJson(`${contextPath}/program/select/export`, data);
}
export function getProgramList(data) {
    return axios.get(`${contextPath}/program/select`, { params: data });
}
// 联动编程-下发文件至控制器
export function writeProgramFile(data) {
    return axios.postByFormData(`${contextPath}/program/writefile`, data);
}
// 联动编程-下发文件至控制器
export function readProgramFile(data) {
    return axios.postByFormUrl(`${contextPath}/program/readfile`, data);
}
export function setProgramAll(data) {
    return axios.postByFormUrl(`${contextPath}/program/setall`, data);
}
export function updateProgram(data) {
    return axios.postByFormUrl(`${contextPath}/program/upsert`, data);
}
export function removeProgram(data) {
    return axios.postByFormUrl(`${contextPath}/program/delete`, data);
}
export function deleteProgramAll(data) {
    return axios.postByFormUrl(`${contextPath}/program/deleteall`, data);
}
//  授权管理
export function getGrantCache(data) {
    return axios.get(`${contextPath}/detect/getGrantCache`, { params: data });
}
export function getGrant(data) {
    return axios.get(`${contextPath}/detect/getGrant`, { params: data });
}
//  系统单元配置
export function getConfigCache(data) {
    return axios.get(`${contextPath}/config/getcache`, { params: data });
}
export function getConfig(data) {
    return axios.get(`${contextPath}/config/get`, { params: data });
}
// 单元板卡信息
export function getBoardCache(data) {
    return axios.get(`${contextPath}/board/getcache`, { params: data });
}
export function getBoard(data) {
    return axios.get(`${contextPath}/board/get`, { params: data });
}
// 现场部件类型状态
export function getDeviceTypeStat(data) {
    return axios.postByFormUrl(`${contextPath}/detect/getDeviceTypeStat`, data);
}
// 历史记录
export function exportHistory(data) {
    return axios.postByJson(`${contextPath}/history/list/export`, data);
}
export function getHistory(data) {
    return axios.postByJson(`${contextPath}/history/list`, data);
}
export function getDictList(data) {
    return axios.get(`${contextPath}/dict/list`, { params: data });
}
export function controllerUpload(data) {
    return axios.postByFormUrl(`${contextPath}/history/controllerUpload`, data);
}

export function getDeviceData(data) {
    return axios.postByFormUrl(`${contextPath}/responseDuration/getDeviceData`, data);
}

export function stop(data) {
    return axios.postByFormUrl(`${contextPath}/responseDuration/stop`, data);
}

//探测器模拟曲线
export function getDeviceAnalog(data) {
    return axios.postByFormUrl(`${contextPath}/responseDuration/getDeviceAnalog`, data);
}

// 组网配置
export function getNetworkModel(data) {
    return axios.postByFormUrl(`${contextPath}/network/getNetworkModel`, data);
}
export function setControllerNo(data) {
    return axios.postByFormUrl(`${contextPath}/network/setControllerNo`, data);
}
export function getNetworkController(data) {
    return axios.postByFormUrl(`${contextPath}/network/getNetworkController`, data);
}
export function setNetworkModel(data) {
    return axios.postByJson(`${contextPath}/network/setNetworkModel`, data);
}
export function setNetworkController(data) {
    return axios.postByJson(`${contextPath}/network/setNetworkController`, data);
}
// 控制器操作
export function recordOperation(data) {
    return axios.postByFormUrl(`${contextPath}/record/operation`, data);
}
export function stopRecord(data) {
    return axios.postByFormUrl(`${contextPath}/record/stop`, data);
}
// 注册地址
export function getRegeditDevice(data) {
    return axios.postByFormUrl(`${contextPath}/regedit/device`, data);
}

//回路状态浏览
export function getLoopSignal(data) {
    return axios.postByFormUrl(`${contextPath}/responseDuration/getLoopSignal`, data);
}
//刷新
export function getRefresh(data){
    return axios.get(`${contextPath}/schedule`, { params: data });
}
//确定
export function compelte(data){
    return axios.postByFormUrl(`${contextPath}/schedule/compelte`, data);
}
//取消
export function cancel(data){
    return axios.postByFormUrl(`${contextPath}/schedule/cancel`, data);
}

// 获取注释以及部件类型
export function getTypeDescr(data){
    return axios.get(`${contextPath}/responseDuration/selectLoop`, { params: data });
}
